import { view, i18next, site, history } from '@yola/ws-sdk';
import config from 'src/js/modules/config';
import store from 'src/js/store';
import constants from '../constants';
import verifiers from '../verifiers';

const { attributes } = constants;

const setDefaultAttributes = (liveDocument) => {
  const elements = liveDocument.querySelectorAll('ws-contact-form-container');
  const businessEmails = site.accessors.getUserEmails() || [];
  const isBuilderEnabled = verifiers.isBuilderEnabled();

  const defaultValues = [
    {
      value: config.accessors.getContactFormSubmissionUrl(),
      key: attributes.ACTION,
    },
    {
      value: businessEmails.join(', '),
      key: attributes.EMAILS,
    },
    isBuilderEnabled
      ? {
          value: config.accessors.getHcaptchaKey(),
          key: attributes.HCAPTCHA_KEY,
        }
      : {
          value: config.accessors.getRecaptchaKey(),
          key: attributes.RECAPTCHA_KEY,
        },
    {
      value: i18next.t('Your message was successfully sent.'),
      key: attributes.SUCCESS_MESSAGE,
    },
  ];

  if (elements.length > 0) {
    const operations = [];

    defaultValues.forEach((defaultValue) => {
      const { key, value } = defaultValue;
      elements.forEach((element) => {
        if (element.hasAttribute(key)) return;
        const elementId = view.accessors.getLiveElementId(element);
        operations.push([view.operations.setElementAttribute, [elementId, key, value]]);
      });
    });

    if (operations.length) {
      view.operations.bulkViewOperations(operations, { skipDesignAutomation: true });

      /*
       * After inserting block with contact form, we run `bulkViewOperations` to set default attributes
       * for contact form, but this action affects the history, so we need to merge it.
       * Without `mergeHistory`, changes of `bulkViewOperations` will be applied
       * again, during view reload on undo action. So we won't be able to undo form insertion.
       *
       * It's a temporary solution, until we have a better way to set up elements on view load.
       * So AVOID using `mergeHistory` in other places.
       * */
      store.dispatch(
        history.actions.mergeHistory({
          stepCount: 1,
          keyPhrase: history.actions.mergeHistory.I_KNOW_THAT_I_AM_PERFORMING_A_DANGEROUS_OPERATION,
        })
      );
    }
  }

  return liveDocument;
};

export default setDefaultAttributes;
